import { Box, styled } from '@mui/material';
import { colors } from 'components/Colors';

const FooterWrapper = styled(Box)`
  border-top: 2px solid ${({ theme }) => theme.palette.info.light};
  display: flex;
  align-items: center;
  min-height: 74px;
  padding-left: 100px;
  padding-top: 20px;

  ${({ theme }) => theme.breakpoints.down('lg')} {
    background-color: ${colors.green.lightTeal.value};
    padding-left: 49px;
    padding-top: 0;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    min-height: 100px;
    padding-left: 0;
    flex-flow: column;
    justify-content: center;
  }
`;

export default FooterWrapper;
